<template>
  <div class="container" style="padding-top: 10%;">
    {{ StoreLangTranslation.data['you_are_being_redirected'][StoreLang] }}
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ServiceFunctions } from '@/wam/modules/service';
import store from '@/store';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import { mapGetters } from 'vuex';
export default {
  name: 'systemvariable',
  computed: mapGetters({
    StoreLangTranslation: 'StoreLangTranslation',
    StoreLang: 'StoreLang',
  }),
  components: {
    PageInfo,
  },
  props: {},
  data () {
    return {
      d_datasetId: '',

    };
  },
  created: function () {
    this.f_checkDatasetIdAndPush();
  },
  beforeMount () {},
  mounted: function () {},
  methods: {
    f_checkDatasetIdAndPush: function () {
      this.d_datasetId = this.$route.query.did;
      if (this.d_datasetId) {
        let query = 'did=' + this.d_datasetId;
        let data = {};
        ServiceFunctions.dataset_check_with_did(query, data)
          .then(resp => {
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              if (resp.data.user_shop_client_id && resp.data.user_shop_bundle_client_id) {
                this.$router.push({ path: this.StoreLangTranslation.data['page_details'][this.StoreLang], query: {'user_shop_client_id': resp.data.user_shop_client_id, 'user_shop_bundle_client_id': resp.data.user_shop_bundle_client_id} });
              } else {
                this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
              }
            } else {
              this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
            }
          });
      } else {
        this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
      }

    }
  }
};

</script>

